import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowConsent(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border shadow-lg animate-in slide-in-from-bottom-5">
      <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-5 md:py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 sm:gap-4">
          <div className="flex-1 pr-8 md:pr-0">
            <h3 className="text-base sm:text-lg font-semibold text-foreground mb-1.5 sm:mb-2">
              Consentimento de Cookies
            </h3>
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
              Usamos cookies para melhorar sua experiência em nosso site, 
              personalizar conteúdo e analisar nosso tráfego. Ao clicar em "Aceitar", 
              você concorda com o uso de cookies conforme descrito em nossa política de privacidade.
            </p>
          </div>
          
          <div className="flex items-center gap-2 sm:gap-3 w-full md:w-auto">
            <Button
              variant="outline"
              onClick={handleReject}
              className="whitespace-nowrap flex-1 md:flex-none touch-manipulation"
              size="lg"
            >
              Recusar
            </Button>
            <Button
              onClick={handleAccept}
              className="whitespace-nowrap flex-1 md:flex-none touch-manipulation"
              size="lg"
            >
              Aceitar Cookies
            </Button>
          </div>
          
          <button
            onClick={handleReject}
            className="absolute top-3 right-3 sm:top-4 sm:right-4 md:relative md:top-0 md:right-0 text-muted-foreground hover:text-foreground transition-colors p-2 touch-manipulation"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;